import './DonateSection.css';

// PayPal donation form values
const PAYPAL_BUSINESS = 'RA47NX2C6RDHL';
const PAYPAL_ITEM_NAME = 'Special & Beyond';

const uses = [
  { emoji: '🌐', text: 'Keep the website running & hosted' },
  { emoji: '📚', text: 'Add new educational content about disabilities' },
  { emoji: '🌍', text: 'Grow the world map of stories' },
  { emoji: '💜', text: "Support Izzi's community & awareness efforts" },
];

export default function DonateSection({ compact = false }) {
  if (compact) {
    // Small version for the Footer
    return (
      <div className="donate-compact">
        <span className="donate-compact-heart">💜</span>
        <div>
          <strong>Support Special and Beyond</strong>
          <p>Help keep this site free for every kid in the world</p>
        </div>
        <div className="donate-compact-btns">
          <PayPalForm className="donate-btn donate-btn-paypal" label="Donate with PayPal" />
        </div>
      </div>
    );
  }

  // Full version for Home page
  return (
    <section className="donate-section">
      <div className="container">
        <div className="donate-box">
          <div className="donate-left">
            <div className="donate-badge">💜 Completely Optional</div>
            <h2>Help Keep Special and Beyond Free</h2>
            <p className="donate-desc">
              This website was made with love by an 8-year-old girl for her sister
              and for kids all over the world. It will always be{' '}
              <strong>100% free</strong> to use. But if you'd like to help it
              grow, even a small donation means the world to Emmi and Izzi. 🌟
            </p>

            <ul className="donate-uses">
              {uses.map((u, i) => (
                <li key={i}>
                  <span>{u.emoji}</span>
                  <span>{u.text}</span>
                </li>
              ))}
            </ul>

            <p className="donate-note">
              No account needed. No pressure. Every penny goes directly toward
              keeping this site running and making it better. 💜
            </p>
          </div>

          <div className="donate-right">
            <div className="donate-heart-graphic" aria-hidden="true">
              <span className="dh-big">💜</span>
              <span className="dh-1">🌟</span>
              <span className="dh-2">🌈</span>
              <span className="dh-3">🌸</span>
              <span className="dh-4">🤝</span>
            </div>

            <div className="donate-buttons">
              <PayPalForm className="donate-cta donate-cta-paypal" showSubtext />
            </div>

            <p className="donate-thanks">
              Thank you so much from the bottom of our hearts 💜<br />
              — Emmi &amp; Izzi
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

// PayPal donation form component
function PayPalForm({ className, label, showSubtext }) {
  return (
    <form
      action="https://www.paypal.com/donate"
      method="post"
      target="_top"
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}
    >
      <input type="hidden" name="business" value={PAYPAL_BUSINESS} />
      <input type="hidden" name="no_recurring" value="0" />
      <input type="hidden" name="item_name" value={PAYPAL_ITEM_NAME} />
      <input type="hidden" name="currency_code" value="USD" />
      <button type="submit" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'inherit', alignItems: 'inherit', gap: 'inherit', color: 'inherit', font: 'inherit', width: '100%' }}>
        <PaypalIcon />
        {showSubtext ? (
          <span>
            <strong>Donate with PayPal</strong>
            <small>Any amount helps!</small>
          </span>
        ) : (
          <span>{label || 'Donate with PayPal'}</span>
        )}
      </button>
    </form>
  );
}

// Inline PayPal logo — no image dependency needed
function PaypalIcon() {
  return (
    <svg className="paypal-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M7.144 19.532l1.049-6.632.2.003c3.274 0 5.836-1.489 6.557-4.887.703-3.28-1.383-5.016-4.903-5.016H5.352a.96.96 0 0 0-.949.812L2.013 19.322a.577.577 0 0 0 .57.668h3.84a.96.96 0 0 0 .721-.458zm10.473-9.5c-.661 3.14-2.886 5.018-6.42 5.018l-.264-.003-1.042 6.595a.576.576 0 0 0 .568.666h3.356c.437 0 .81-.317.878-.749l.36-2.279.025-.159a.888.888 0 0 1 .877-.748h.553c3.58 0 6.383-1.455 7.2-5.664.342-1.755.166-3.22-.737-4.25a3.54 3.54 0 0 0-1.01-.819c-.27 1.12-.719 2.113-1.344 2.973-.001 0 0 0 0 0z"/>
    </svg>
  );
}
